import ChildrenTableRow from '@/components/ChildrenTableRow/ChildrenTableRow';

export default ChildrenTableRow;
